import i18next from 'i18next';

import seoHelper from '@common/lib/helpers/seo';

export const contactsSeo = (t: i18next.TFunction) => {
  return seoHelper.getSeo(t, {
    title: t('contacts:seoTitle'),
  });
};
